import { useEffect } from 'react';
import './NotFound.scss';
import { applySeo } from '../../utils/seo';

const NotFound = () => {
    useEffect(() => {
        applySeo({
            title: 'Page Not Found | AstroDavido',
            description: 'The page you were looking for could not be found.',
            canonicalPath: window.location.pathname,
            robots: 'noindex,follow'
        });
    }, []);

    return (
        <div className='not-found'>
            <a href='/'>
            <img src='../images/not-found.png' alt='404 - not found' />
            </a>
        </div>
    )
}

export default NotFound;
